var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C323F",
    d: "M9.335.005c-.043.004-.18.018-.303.028-2.837.256-5.495 1.787-7.179 4.14A9.89 9.89 0 0 0 .09 8.538c-.08.549-.09.71-.09 1.455 0 .744.01.906.09 1.455.543 3.751 3.212 6.903 6.833 8.071.649.21 1.332.352 2.11.438.302.033 1.61.033 1.913 0 1.342-.149 2.479-.48 3.6-1.053.171-.088.205-.111.181-.13-.016-.013-.748-.995-1.627-2.182l-1.597-2.158L9.5 11.47a284.442 284.442 0 0 0-2.015-2.96 160.9 160.9 0 0 0-.02 2.921c-.006 2.814-.008 2.927-.043 2.994a.355.355 0 0 1-.172.178c-.062.03-.117.037-.412.037h-.338l-.09-.057a.365.365 0 0 1-.13-.143l-.041-.087.004-3.916.005-3.918.06-.076a.536.536 0 0 1 .145-.119c.08-.039.112-.043.45-.043.398 0 .464.016.568.129.03.031 1.113 1.664 2.41 3.63l3.94 5.97 1.583 2.397.08-.053a10.247 10.247 0 0 0 2.052-1.8 9.944 9.944 0 0 0 2.352-5.107c.08-.55.09-.711.09-1.455 0-.744-.01-.906-.09-1.455-.543-3.752-3.213-6.904-6.834-8.072a10.488 10.488 0 0 0-2.08-.435 25.82 25.82 0 0 0-1.64-.026Zm4.09 6.043c.093.047.17.136.197.23.015.051.02 1.137.015 3.584l-.005 3.511-.62-.949-.62-.949V8.922c0-1.65.007-2.577.019-2.622.031-.11.1-.196.193-.246.08-.041.11-.045.416-.045.29 0 .34.004.405.039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo08);
export default __webpack_public_path__ + "static/media/logo-08.d338e6cbccdb2939e5097393dd1efed8.svg";
export { ForwardRef as ReactComponent };